import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import getAPI from "@API/index";
import { FinDataRequest } from "@Dao/responseTypes";

export const useFormType = () => {
  const { id: finDataRequestId } = useParams<{ id: string }>();
  const [formType, setFormType] = useState<"Default" | "Simplified" | undefined>("Default");

  useEffect(() => {
    if (!finDataRequestId) return;
    getAPI()
      .request<FinDataRequest>({ url: `/api/FinDataRequest/${finDataRequestId}` })
      .then((res) => setFormType(res.formType || "Default"))
      .catch(() => setFormType("Default"));
  }, [finDataRequestId]);

  return formType;
};
